import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'radius-bottom-left', 'IconRadiusBottomLeft', [["path",{"d":"M19 19h-6a8 8 0 0 1 -8 -8v-6","key":"svg-0"}]]);